import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { auth } from "../../../config/firebase";
import { deleteProperty } from "../api/propertiesApi";
import { Property } from "@stratify/shared";

interface DeletePropertyDialogProps {
  open: boolean;
  onClose: () => void;
  property: Property;
}

export const DeletePropertyDialog: React.FC<DeletePropertyDialogProps> = ({
  open,
  onClose,
  property,
}) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    if (!auth.currentUser?.uid || !property.id) return;

    try {
      await deleteProperty(auth.currentUser.uid, property.id);
      navigate("/properties");
    } catch (error) {
      console.error("Failed to delete property:", error);
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Property</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this property? This action cannot be
          undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid="cancel-delete-button">
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          data-testid="confirm-delete-button"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
